import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

export interface Props {
  className?: string;
  fillColor?: string;
}

const PhoneIcon = (props: Props) => {
  const { className } = props;
  const fillColor = props.fillColor || "#bababa";

  return (
    <SvgIcon className={className} viewBox="0 0 12 20">
      <g transform="matrix(1 0 0 1 -86 -2793 )">
        <path
          d="M 12 2.27272727272727  C 12 1.01818181818182  10.9661538461538 0  9.69230769230769 0  L 2.30769230769231 0  C 1.03384615384615 0  0 1.01818181818182  0 2.27272727272727  L 0 17.7272727272727  C 0 18.9818181818182  1.03384615384615 20  2.30769230769231 20  L 9.69230769230769 20  C 10.9661538461538 20  12 18.9818181818182  12 17.7272727272727  L 12 2.27272727272727  Z M 7.38461538461539 17.7272727272727  C 7.38461538461539 18.4818181818182  6.76615384615385 19.0909090909091  6 19.0909090909091  C 5.23384615384615 19.0909090909091  4.61538461538462 18.4818181818182  4.61538461538462 17.7272727272727  C 4.61538461538462 16.9727272727273  5.23384615384615 16.3636363636364  6 16.3636363636364  C 6.76615384615385 16.3636363636364  7.38461538461539 16.9727272727273  7.38461538461539 17.7272727272727  Z M 10 2.72727272727273  L 10 15.4545454545455  L 2 15.4545454545455  L 2 2.72727272727273  L 10 2.72727272727273  Z "
          fillRule="nonzero"
          fill={fillColor}
          stroke="none"
          transform="matrix(1 0 0 1 86 2793 )"
        />
      </g>
    </SvgIcon>
  );
};

export default PhoneIcon;
